import { z } from "zod";

export const ErrorResponseSchema = z.object({
    code: z.number(),
    message: z.string(),
    errors: z.record(z.array(z.string())).optional(),
    success: z.boolean(),
});